import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { AtlasDisplay } from 'garaje/utils/atlas';

export default class MapsSignageIndexController extends Controller {
  @tracked declare displays: AtlasDisplay[];

  @action
  removeDisplay(id: string): void {
    this.displays = this.displays.filter((d) => d.id !== id);
  }
}
